import { Link, useNavigate } from "@tanstack/react-router";
import { Heart, MessageCircle, LineChart, Users, CalendarHeart, LogOut, Crown, CreditCard } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/dashboard", label: "Home", icon: Heart },
  { to: "/chat", label: "Sage AI", icon: MessageCircle },
  { to: "/mood", label: "Mood", icon: LineChart },
  { to: "/counseling", label: "Counseling", icon: Users },
  { to: "/therapists", label: "Therapists", icon: CalendarHeart },
  { to: "/pricing", label: "Premium", icon: Crown },
  { to: "/billing", label: "Billing", icon: CreditCard },
];


export function AppNav() {
  const navigate = useNavigate();
  const signOut = async () => {
    await supabase.auth.signOut();
    navigate({ to: "/" });
  };
  return (
    <header className="sticky top-0 z-40 border-b border-border/40 backdrop-blur-xl bg-background/60">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between gap-6">
        <Link to="/dashboard" className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-xl bg-gradient-to-br from-primary to-accent glow-primary" />
          <span className="font-display text-xl">Serenity</span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="px-3 py-2 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-secondary/50 transition flex items-center gap-2"
              activeProps={{ className: "px-3 py-2 rounded-lg text-sm text-foreground bg-secondary/80 flex items-center gap-2" }}
            >
              <l.icon className="h-4 w-4" />
              {l.label}
            </Link>
          ))}
        </nav>
        <Button variant="ghost" size="sm" onClick={signOut}>
          <LogOut className="h-4 w-4" />
        </Button>
      </div>
      <nav className="md:hidden flex items-center gap-1 overflow-x-auto px-4 pb-3">
        {links.map((l) => (
          <Link key={l.to} to={l.to} className="shrink-0 px-3 py-1.5 rounded-lg text-xs text-muted-foreground flex items-center gap-1.5"
            activeProps={{ className: "shrink-0 px-3 py-1.5 rounded-lg text-xs text-foreground bg-secondary flex items-center gap-1.5" }}>
            <l.icon className="h-3.5 w-3.5" />
            {l.label}
          </Link>
        ))}
      </nav>
    </header>
  );
}
